module.exports = __webpack_public_path__ + "img/BiologyEx.9b4441f4.svg";